// Running a card action chosen by the player (a button from getActions), shared
// by Card.svelte's popover and the phone's inspector.
import { get } from 'svelte/store';
import { state, ui, prefs } from './stores.js';
import { skipForManualAction, withTurnHeld, pushChoice, backupChoice, restoreChoice } from './ui.js';
import { doAction, updateState } from './game.js';

// Held so a skipped prompt can't move the turn on before the action resolves
export function fireCardAction(c, type, forceManual = false){
    return withTurnHeld(() => fireCardActionNow(c, type, forceManual));
}

async function fireCardActionNow(c, type, forceManual){
    // TODO !!! add undo save here
    let player = get(state).players[get(ui).viewing];
    await skipForManualAction();
    let savedHints = get(prefs).showHints;
    if(forceManual){
        prefs.update(p => {
            p.showHints = false;
            return p;
        })
    }
    console.log('firing card action: resetting cache');
    state.update(s => {
        s.cache = {
            allPrev: [],
        };
        delete s.payingCost;
        return s;
    })
    let backup = backupChoice();
    pushChoice({
        fca: c.uniqueID,
        p: player,
        type
    })
    let result = await doAction(player, type, {card: c.uniqueID, obj: c.uniqueID});
    console.log('fca completed: result', result)
    if(result == 'cancelled'){
        restoreChoice(backup);
        await updateState();
    }

    if(forceManual){
        prefs.update(p => {
            p.showHints = savedHints;
            return p;
        })
    }
}
